import React, { useEffect } from 'react'
import { DownloadOutlined, ExclamationCircleFilled, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, DatePicker, Input, InputNumber, Modal, Radio, Row, Select, Space, Table, Tabs, Typography } from 'antd';
import { useRef, useState } from 'react';
import Highlighter from 'react-highlight-words';
import { exportUsersToExcel, singleLocClear, viewUsers } from '../../api/AdminRequest';
// import { Modal } from 'antd';
// import DrawerBox from '../drawer/Drawer';
// import CardDrawer from '../admin/cardsDrawer/CardDrawer';
import UserDrawer from '../drawer/UserDrawer';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const { confirm } = Modal;
const { Title } = Typography;


function ActiveUsers() {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [users, setUsers] = useState([])
    const [adminUsers, setAdminUsers] = useState([])
    const [normalUsers, setNormalUsers] = useState([])

    const [change, setChange] = useState('')
    const [viewId, setViewID] = useState('')
    const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(true)
    // const [cardViewId,setCardViewId] = useState('')
    // const [openCard, setOpenCard] = useState(false);
    const [tabIndex, setTabIndex] = useState('')
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 15,
        total: 0,
        totalPages: 0,
        hasMore: false
    })
    const [userType, setUserType] = useState('') // '', 'admin', 'normal'
    const [exportModalOpen, setExportModalOpen] = useState(false)
    const [exportUserType, setExportUserType] = useState('all')
    const [exportAll, setExportAll] = useState(true)
    const [exportCount, setExportCount] = useState(10)
    const [exportLoading, setExportLoading] = useState(false)
    const [exportStatus, setExportStatus] = useState('all')
    const [exportDateRange, setExportDateRange] = useState(null)
    const [exportExpired, setExportExpired] = useState('all')

    const navigate = useNavigate()
    const location = useLocation()



    const showDrawer = async (ID) => {
        setViewID(ID)
        setOpen(true);

    };
    const onClose = () => {
        setOpen(false);
    };

    // const showCardDrawer = async (ID) => {
    //     // console.log(ID,'iiiiiiiiiiiiiiiiidddddddddddd');
    //     setCardViewId(ID)
    //     setOpenCard(true);

    // };

    // const onCloseCard = () => {
    //     setOpenCard(false);
    // };

    const showCards = async (ID) => {
        // console.log(ID,'iiiiiiiiiiiiiiiiidddddddddddd');
        navigate("/cards", { state: { details: ID, status: 'user', from: location } })

    };

    const handleExport = async () => {
        try {
            setExportLoading(true)
            const params = {
                userType: exportUserType === 'all' ? '' : exportUserType,
                limit: exportAll ? 'all' : exportCount,
                status: exportStatus,
                startDate: exportDateRange ? exportDateRange[0].toISOString() : '',
                endDate: exportDateRange ? exportDateRange[1].toISOString() : '',
                expiredFilter: exportExpired,
            };
            const response = await exportUsersToExcel(params);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const d = new Date();
            const ds = `${String(d.getDate()).padStart(2,'0')}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getFullYear()).slice(-2)}:${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
            link.setAttribute('download', `ZEEQR_Users_Export_${ds}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setExportModalOpen(false);
        } catch (error) {
            console.log(error);
        } finally {
            setExportLoading(false)
        }
    };

    // Single source of truth for fetching users.
    // Triggered by: initial mount, `change` (after edits), userType switch, and manual pagination.
    useEffect(() => {
        const getUsers = async () => {
            try {
                setLoader(true)
                const { data } = await viewUsers(pagination.current, pagination.pageSize, userType)
                setUsers(data?.users || [])

                if (data?.pagination) {
                    setPagination(prev => ({
                        ...prev,
                        current: data.pagination.currentPage,
                        pageSize: data.pagination.limit,
                        total: data.pagination.totalUsers,
                        totalPages: data.pagination.totalPages,
                        hasMore: data.pagination.hasMore
                    }))
                }

                const adUser = (data?.users || []).filter((u) => u?.adminID)
                setAdminUsers(adUser)
                const norUser = (data?.users || []).filter((u) => !u?.adminID)
                setNormalUsers(norUser)
            } catch (error) {
                console.log(error.message)
            } finally {
                setLoader(false)
            }
        }
        getUsers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [change, userType, pagination.current, pagination.pageSize])

    // Table pagination / page-size changes just update state — the effect above does the fetch.
    const handleTableChange = (paginationConfig) => {
        setPagination(prev => ({
            ...prev,
            current: paginationConfig.current,
            pageSize: paginationConfig.pageSize
        }))
    }


    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        className='bg-blue-800'
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    {/* <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button> */}
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            clearFilters && handleReset(clearFilters)
                            handleSearch(selectedKeys, confirm)
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1890ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });
    const columns = [
        {

            title: 'No.',
            dataIndex: '_id',
            key: 'index',
            width: '10%',
            render: (text, record, index) =>
                (pagination.current - 1) * pagination.pageSize + index + 1,

        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '30%',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Admin Name',
            dataIndex: 'adminID',
            key: 'adminID',
            width: '20%',
            render: (adminID) => {
                return (
                    <div>
                        <p>{adminID ? adminID.name : 'nil'}</p>
                    </div>
                )
            }
        },

        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: '30%',
            ...getColumnSearchProps('email'),
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: '20%',
            // ...getColumnSearchProps('status'),
            render: (status) => { return status === 'active' ? <p className=' text-center'>Active</p> : <p className='bg-red-500 text-white text-center rounded-xl'>Blocked</p> },
        },
        // {
        //     title: 'Profile',
        //     dataIndex: '_id',
        //     key: 'address',
        //     render: (_id) => <Button className='w-24 bg-slate-300 hover:bg-slate-200' onClick={() => showDrawer(_id)} >View</Button>

        // },
        {
            title: 'View',
            dataIndex: 'status._id',
            key: '_id',
            render: (status, _id) => {
                return (
                    <Button className='w-24 bg-slate-300 hover:bg-slate-200' onClick={() => showDrawer(_id)} >View</Button>
                )
            }

        },
        // {
        //     title: 'Cards',
        //     dataIndex: '_id',
        //     key: '_id',
        //     render: (_id) => <Button className='w-24 bg-slate-300 hover:bg-slate-200' onClick={() => showCardDrawer(_id)} >Cards</Button> 

        // },
        {
            title: 'Cards',
            dataIndex: 'status._id',
            key: '_id',
            render: (status, _id) => <Button className='w-24 bg-slate-300 hover:bg-slate-200' onClick={() => showCards(_id)} >Cards</Button>

        },
        //   {
        //             title: 'Action',
        //             dataIndex: '_id',
        //             key: '_id',
        //             render: (_id) => {
        //                 return (
        //                     <Button   className="text-red-500 border-red-500 border-[1px] font-semibold text-[12px]" onClick={() =>handleClearLocation(_id, "card")
        //                     } >Location Clear</Button>
        //                 )
        //             }

        //         },

    ];

    // Tab switch just updates tabIndex/userType and resets to page 1 — the effect does the rest.
    const onChange = (key) => {
        setTabIndex(key)

        let newUserType = ''
        if (key === '2') newUserType = 'adminuser'
        else if (key === '3') newUserType = 'normal'

        setUserType(newUserType)
        setPagination(prev => ({ ...prev, current: 1 }))
    };
    const items = [
        {
            key: '1',
            label: `All Users`,
            children: [
                <div className='flex justify-center overflow-x-auto '>

                    <div className='w-full mt-5 '>
                        <Table
                            columns={columns}
                            loading={loader}
                            dataSource={users}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
                                pageSizeOptions: ['10', '15', '20', '50', '100']
                            }}
                            onChange={handleTableChange}
                        />
                        <UserDrawer viewId={viewId} setChange={setChange} users={'users'} open={open} onClose={onClose} />
                        {/* <CardDrawer  cardViewId={cardViewId} openCard={openCard} onCloseCard={onCloseCard} users={'users'} /> */}
                    </div>
                </div>
            ],
        },
        {
            key: '2',
            label: `Admin User`,
            children: [
                <div className='flex justify-center '>

                    <div className='w-full mt-5 '>
                        <Table
                            columns={columns}
                            loading={loader}
                            dataSource={adminUsers}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
                                pageSizeOptions: ['10', '15', '20', '50', '100']
                            }}
                            onChange={handleTableChange}
                        />
                        <UserDrawer viewId={viewId} setChange={setChange} users={'users'} open={open} onClose={onClose} />
                        {/* <CardDrawer  cardViewId={cardViewId} openCard={openCard} onCloseCard={onCloseCard} users={'users'} /> */}
                    </div>
                </div>
            ],
        },
        {
            key: '3',
            label: `Normal User`,
            children: [
                <div className='flex justify-center '>

                    <div className='w-full mt-5 '>
                        <Table
                            columns={columns}
                            loading={loader}
                            dataSource={normalUsers}
                            pagination={{
                                current: pagination.current,
                                pageSize: pagination.pageSize,
                                total: pagination.total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
                                pageSizeOptions: ['10', '15', '20', '50', '100']
                            }}
                            onChange={handleTableChange}
                        />
                        <UserDrawer viewId={viewId} setChange={setChange} users={'users'} open={open} onClose={onClose} />
                        {/* <CardDrawer  cardViewId={cardViewId} openCard={openCard} onCloseCard={onCloseCard} users={'users'} /> */}

                    </div>
                </div>
            ],
        },
    ];
    return (
        <>
            <Row gutter={16}>
                <Col span={12}>
                    <Title level={2}>Users Profile</Title>
                </Col>
                <Col span={12} className='text-right'>
                    <Link className='add-button rounded-lg ml-auto' to="/create-user"><PlusOutlined />Add user</Link>
                    <Button className='add-button rounded-lg ml-2' icon={<DownloadOutlined />} onClick={() => setExportModalOpen(true)}>Export Excel</Button>
                </Col>
            </Row>

            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />

            <Modal
                title="Export Users to Excel"
                open={exportModalOpen}
                onCancel={() => setExportModalOpen(false)}
                footer={[
                    <Button key="cancel" onClick={() => setExportModalOpen(false)}>Cancel</Button>,
                    <Button key="export" type="primary" className='bg-blue-800' loading={exportLoading} onClick={handleExport}>Export</Button>,
                ]}
            >
                <div className='py-4'>
                    <p className='mb-2 font-medium'>Select User Type:</p>
                    <Radio.Group value={exportUserType} onChange={(e) => setExportUserType(e.target.value)}>
                        <Radio value="all">All Users</Radio>
                        <Radio value="adminuser">Admin Users</Radio>
                        <Radio value="normal">Normal Users</Radio>
                    </Radio.Group>
                </div>
                <div className='py-2'>
                    <Checkbox checked={exportAll} onChange={(e) => setExportAll(e.target.checked)}>
                        Export all users
                    </Checkbox>
                    {!exportAll && (
                        <div className='mt-2'>
                            <span className='mr-2'>Number of users to export:</span>
                            <InputNumber min={1} value={exportCount} onChange={(val) => setExportCount(val)} />
                        </div>
                    )}
                </div>
                <div className='py-2'>
                    <p className='mb-2 font-medium'>Status:</p>
                    <Select value={exportStatus} onChange={(val) => setExportStatus(val)} style={{ width: 200 }}>
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value="active">Active</Select.Option>
                        <Select.Option value="blocked">Blocked</Select.Option>
                    </Select>
                </div>
                <div className='py-2'>
                    <p className='mb-2 font-medium'>Created Date Range:</p>
                    <DatePicker.RangePicker value={exportDateRange} onChange={(dates) => setExportDateRange(dates)} />
                </div>
                <div className='py-2'>
                    <p className='mb-2 font-medium'>Plan Expiry:</p>
                    <Select value={exportExpired} onChange={(val) => setExportExpired(val)} style={{ width: 200 }}>
                        <Select.Option value="all">All</Select.Option>
                        <Select.Option value="expired">Expired users</Select.Option>
                        <Select.Option value="active_plan">Active plan only</Select.Option>
                    </Select>
                </div>
            </Modal>

            {/* <div className='flex justify-center '>

                <div className='w-full mt-5 '>
                    <Table columns={columns} loading={loader} dataSource={users} />
                    <DrawerBox viewId={viewId} setDeletes={setDeletes} open={open} onClose={onClose} />
                </div>
            </div> */}
        </>
    )
}

export default ActiveUsers